<!--
 * @Descripttion:'大屏'
 * @version: 1.0.0
 * @Author: Jiang ShareFont
 * @Date: 2023-03-15 17:07:40
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-05-19 13:56:01
-->
<template>
  <div class="wallBox largeScreen-homePage editTarget-largeScreen-homePage"
    :style="{ backgroundImage: 'url(' + skinList[skinIndex].bg + ')' }">
    <div class="full-body" style="" @click="fullHandle">
      <div class="body">
        <div class="vdrStatic"
          style="top: 72px;left: 137px;z-index: 21;background-size: 100% 100% !important;width: 102px;height: 103px;"
          :style="{ backgroundImage: 'url(' + require('@/assets/image/logo.png') + ')' }"></div>
        <div class="vdrStatic"
          style="top: 104px;left: 261px;z-index: 21;font-size: 26px;color: rgb(246, 243, 255);text-shadow: rgba(255, 255, 255, 0) -1px -1px 0px,rgba(255, 255, 255, 0) 0px -1px 0px,rgba(255, 255, 255, 0) 1px -1px 0px,rgba(255, 255, 255, 0) 1px 0px 0px,rgba(255, 255, 255, 0) 1px 1px 0px,rgba(255, 255, 255, 0) 0px 1px 0px,rgba(255, 255, 255, 0) -1px 1px 0px,rgba(255, 255, 255, 0) -1px 0px 0px;min-width: 320px;height: 41px;">
          <div class="myEditText">主办单位：{{ detail.organizer }}</div>
        </div>
        <div class="vdrStatic"
          style="top: 94px;left: 567px;z-index: 21;font-size: 40px;color: rgb(246, 243, 255);text-shadow: rgba(255, 255, 255, 0) -1px -1px 0px,rgba(255, 255, 255, 0) 0px -1px 0px,rgba(255, 255, 255, 0) 1px -1px 0px,rgba(255, 255, 255, 0) 1px 0px 0px,rgba(255, 255, 255, 0) 1px 1px 0px, rgba(255, 255, 255, 0) 0px 1px 0px,rgba(255, 255, 255, 0) -1px 1px 0px,rgba(255, 255, 255, 0) -1px 0px 0px;min-width: 1100px;height: 61px;">
          <div class="myEditText" style="text-align:center;">大转盘抽奖现场大屏互动</div>
        </div>
        <div class="vdrStatic JS_SoundHander" style="top: 197px;left: 1693px;z-index: 21;width: 90px;height: 90px;">
          <div class="soundBox  pointerDom" :class="musicPlay == true ? 'soundPlay' : 'soundOff'" @click="musicClick">
          </div>
        </div>
        <div class="vdrStatic pointerVdr JS_WinListHander" @click="showWinListHander"
          style="top: 328px;left: 1693px;z-index: 21;background-size: 100% 100% !important;width: 92px;height: 110px;"
          :style="{ backgroundImage: 'url(' + require('@/assets/image/winningList.png') + ')' }"></div>
        <div>
          <div class="vdrStatic pointerVdr JS_ShowQrcodeHander"
            style="top: 478px;left: 1693px;z-index: 21;background-size: 100% 100% !important;width: 92px;height: 110px;"
            @click="fetchQrcode" v-if="showQcode == false"
            :style="{ backgroundImage: 'url(' + require('@/assets/image/showQrCode.png') + ')' }"></div>
          <div
            class="myEditElement pointerDom largeScreen-qrCodeBtn-1 editTarget-largeScreen-qrCodeBtn-1 JS_HideQrcodeHander"
            style="width: 92px; height: 110px; left: 1693px; top: 478px" @click="showQcode = false"
            v-if="showQcode == true"
            :style="{ backgroundImage: 'url(' + require('@/assets/image/hideQrCode.png') + ')' }">
          </div>
          <div
            class="myEditElement pointerDom largeScreen-qrCodeBtn-1 editTarget-largeScreen-qrCodeBtn-1 JS_HideQrcodeHander"
            style="width: 92px; height: 110px; left: 1693px; top: 628px" @click="changeSkin"
            :style="{ backgroundImage: 'url(' + require('@/assets/image/changeSkin.png') + ')' }">
          </div>
        </div>
        <div class="lottery-box flex flex-pack-justify flex-align-center showPage">
          <div class="vdrStatic" style="top: 198px;left: 139px;z-index: 20;width: 400px;height: 720px;">
            <div class="awardInfo">
              <div class="swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" style="width: 260px" v-for="(item, index) in detail.detail" :key="item.id"
                    v-if="item.type != 1">
                    <div class="awardStyleBox flex flex-pack-center flex-align-center">
                      <span class="awardStyle">{{ item.name }}</span>
                    </div>
                    <div class="awardNameBox flex flex-pack-center flex-align-center">
                      <span>{{ item.desc }}</span>
                    </div>
                    <div class="awardImgBox">
                      <img :src="item.cover != '' ? item.cover : coverList[index]" />
                    </div>
                    <div class="awardAmountBox ellipsis" v-if="detail.show_prize_num == 1">奖品剩余数量： {{ item.num -
                      item.hasnum }}</div>
                  </div>
                </div>
              </div>
              <div class="awardJoinNumBox flex flex-pack-center flex-align-center">
                <span class="tip">已参加抽奖人数</span>
                <span class="awardJoinNum ellipsis">{{ detail.join_user_num }}</span>
                <span title="刷新" class="refreshJoinNum" @click="refeshDetail()"></span>
              </div>
              <div class="awardJoinNumBox flex flex-pack-center flex-align-center">
                <span class="tip">每人可抽奖次数</span>
                <span class="awardJoinNum ellipsis">{{ detail.join_num }}</span>
              </div>
            </div>
          </div>
          <div class="vdrStatic" style="top: 198px;left: 567px;z-index: 20;width: 1100px;height: 720px;">
            <div class="lotteryScreen">
              <!---->
              <div>
                <div class="lottery-screen flex flex-wrap flex-align-start">
                  <div class="comment-zone largeScreenScrollBox" id="winBoxScroll" ref="winBoxScroll">
                    <ul class="flex flex-wrap flex-align-start" ref="winBoxScrollUl">
                      <li class="cell flex" v-for="(item, index) in wins" :key="index">
                        <img :src="item.avatar" />
                        <span>{{ item.username }}：手气爆棚，抽中了{{ item.prize }}-{{ item.desc }}</span>
                      </li>
                    </ul>
                  </div>

                </div>

              </div>
            </div>
          </div>
          <VueDragResize v-if="showQcode" :isActive="true" :w="480" :h="550" :minw="50" :minH="50" :x="left" :y="top"
            :gridX="20" :gridY="20" :aspectRatio="true" :parentLimitation="true" :aspect-ratio="true" :isResizable="true"
            :isDraggable="true" v-on:resizing="resize" v-on:dragging="resize" :sticks="['tm', 'bm', 'ml', 'mr']"
            :stickSize="12" :z="999">
            <div class="qr-code-box" style="{borderRadius: 21 * qrCodeScale + 'px', padding: 44 * qrCodeScale + 'px'}"
              :style="{ borderRadius: 21 * qrCodeScale + 'px', padding: 44 * qrCodeScale + 'px', width: +width + 'px', height: +height + 'px' }">
              <div class="qrCodeContent flex flex-pack-center flex-align-center">
                <img :src="ewm" />
              </div>
              <div class="qrCodeTip" :style="{
                fontSize: 30 * qrCodeScale + 'px',
                marginTop: 39 * qrCodeScale + 'px'
              }">
                扫描二维码参与互动大屏幕
              </div>
            </div>
          </VueDragResize>

      </div>
        <!---->
        <div class="audioCtrl">
          <audio id="player" controls="controls" ref="player" loop="loop">
            <source src="@/assets/image/bg_music.mp3" />
          </audio>
          <!-- <audio preload="auto" loop="loop" src="@/assets/image/bg_music.mp3" ref="audio1"></audio> -->
          <!-- <audio preload="auto" loop="loop" src="@/assets/image/lottery_music.mp3"></audio>
                                                                          <audio preload="auto" src="@/assets/image/end_music.mp3"></audio> -->
        </div>
      </div>
    </div>

    <div class="largeScreenPopup winning-list-box" v-show="showWinList">
      <div class="popupContent winning-list showPage">
        <div class="closeRank JS_CloseWinlist" @click="hideWinListHander"></div>
        <div class="winningListBase">
          <div class="winningListContent largeScreenScrollBox">
            <div class="winningItem" v-for="(item, index) in winLists.prize" :key=item.id v-if="item.type != 1">
              <div class="awardLevel">{{ item.name }}：{{ item.desc }} <span v-if="winLists.show_prize_num == 1">×{{
                item.hasnum }}名</span></div>
              <div class="playerList flex flex-wrap" v-if="item.users.length > 0">
                <div class="playerItem" v-for="(citem) in item.users" :key="citem.id">
                  <div class="headImgBox flex flex-pack-center flex-align-center">
                    <img :src="citem.avatar" class="headImg" />
                  </div>
                  <div class="name ellipsis">{{ citem.username }}</div>
                </div>
              </div>
              <div class="morePlayer" @click="MoreWinListHander(item, index)"
                v-if="item.hasnum > 12 && item.fetch === false">加载更多>></div>
              <div class="playerList flex flex-wrap" v-if="item.users.length == 0">
                <div class="noData">暂无人中奖</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="skillSupport flex flex-pack-center flex-align-center" style="zoom: 1.05">
      页面技术由大转盘抽奖工具提供
    </div>
    <LoginBox ref="login"></LoginBox>
    <div class="skin_mask" v-show="skinDIYShow"></div>
    <div class="skinBox" v-show="skinDIYShow">
      <div class="skinItems">
        <div class="skinItem"  v-for="(item,index) in skinList" :key="item.id" :class="index == skinIndex?'active':''" @click="setSKinHander(index)">
          <div class="imgbox">
            <img :src="item.bg" alt="">
          </div>
          <div class="title">{{item.title}}</div>
        </div>
        <div class="skinItem">
          <div class="imgbox">
            <el-upload
              class="upload-demo"
              ref="upload"
              :action="baseUrl+'file.html'"
              :on-success="handleUploadSuccess"
              >
              <img src="@/assets/image/diy_img.png" alt="">
            </el-upload>
          </div>
          <div class="title">上传自定义皮肤</div>
        </div>
      </div>
      <div class="closeBtn" @click="skinCloseHander">
        <img src="@/assets/image/lotteryRankClose.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { getDZPDetail, getDZPPrize, getDZPQrcode, getDZPPage, getDZPSkinList, baseUrl, postDzpSkin } from '../api/api'
import $ from 'jquery'
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import VueDragResize from 'vue-drag-resize'
import cover0 from '../assets/image/prize0.png'
import cover1 from '../assets/image/prize1.png'
import cover2 from '../assets/image/prize2.png'
import cover3 from '../assets/image/prize3.png'
import cover4 from '../assets/image/prize4.png'
import cover5 from '../assets/image/prize5.png'
import cover6 from '../assets/image/prize6.png'
import cover7 from '../assets/image/prize7.png'
import cover8 from '../assets/image/prize8.png'
import cover9 from '../assets/image/prize9.png'
import cover10 from '../assets/image/prize10.png'
import cover11 from '../assets/image/prize11.png'
import cover12 from '../assets/image/prize12.png'
import io from 'socket.io-client'
import LoginBox from './loginBox.vue'

export default {
  name: 'screen',
  data() {
    return {
      lottery_id: '',
      showWinList: false,
      showQcode: false,
      swiper: '',
      width: 480,
      height: 550,
      top: 0,
      left: 0,
      qrCodeScale: 1,
      detail: {},
      coverList: [cover0, cover1, cover2, cover3, cover4, cover5, cover6, cover7, cover8, cover9, cover10, cover11, cover12, cover12, cover12, cover12, cover12, cover12, cover12, cover12],
      winLists: [],
      ewm: '',
      socket: io('wss://wss.zjjunlv.com'), // socket
      isconnect: false,
      wins: [],
      musicPlay: false,
      skinIndex: 0,
      skinList: [{
        'id': '1',
        'title': '钱多多',
        'uid': '0',
        'bg': 'https://static.goubudian.com/Uploads/lottery/2305/6465c7f2d309e.png'
      }],
      baseUrl: baseUrl,
      skinDIYShow: false

    }
  },
  components: {
    VueDragResize, LoginBox
  },
  methods: {
    handleUploadSuccess(res) {
      if (res.code === 200) {
        var obj = {
          bg: res.data.imgurl,
          title: '自定义皮肤'
        }
        postDzpSkin(obj, this.$cookie.getCookie('token')).then(
          response => {
            console.log(response.code)
            if (response.code === 200) {
              this.fetchSkinList()
              this.$message.success('上传成功，请选择您的皮肤吧')
            } else {
              this.$message.error(response.data.msg)
            }
          },
          reject => {
            console.log(reject)
            this.$message.error(reject.data.msg)
          }
        )
      }
    },
    changeSkin() {
      if (this.$cookie.getCookie('token') === '') {
        console.log(this.$cookie.getCookie('token'))
        this.$refs.login.login_fn()
        return false
      }
      this.skinDIYShow = true
      this.fetchSkinList()
    },
    setSKinHander(index) {
      this.skinIndex = index
      this.skinDIYShow = false
      this.fullHandle()
    },
    skinCloseHander() {
      this.skinDIYShow = false
    },
    MoreWinListHander(citem, index) {
      getDZPPage({ lottery_id: this.lottery_id, lottery_detail_id: citem.id, page: citem.page - 0 + 1 }, this.$cookie.getCookie('token')).then((res) => {
        if (res.data.code === 200) {
          if (res.data.data.length > 0) {
            this.winLists.prize[index].users = this.winLists.prize[index].users.concat(res.data.data)
            this.winLists.prize[index].page++
            if (res.data.data.length === 12) {
              this.winLists.prize[index].fetch = false
            } else {
              this.winLists.prize[index].fetch = true
            }
          } else {
            this.winLists.prize[index].fetch = true
          }
        } else {

        }
      })
    },
    musicClick() {
      this.musicPlay = !this.musicPlay
      // this.$refs.audio1.play()
      // console.log(this.$refs.player)
      if (this.musicPlay) {
        this.$refs.player.play()
      } else {
        this.$refs.player.pause()
      }
    },
    fetchQrcode() {
      if (this.$cookie.getCookie('token') === '') {
        console.log(this.$cookie.getCookie('token'))
        this.$refs.login.login_fn()
        return false
      }
      if (!this.ewm) {
        var url
        if (this.detail.lottery_type === '1') {
          url = encodeURIComponent('lottery/jackpot/detail')
        } else if (this.detail.lottery_type === '2') {
          url = encodeURIComponent('lottery/nine/detail')
        } else if (this.detail.lottery_type === '3') {
          url = encodeURIComponent('lottery/yao/detail')
        } else if (this.detail.lottery_type === '4') {
          url = encodeURIComponent('lottery/niu/detail')
        }
        getDZPQrcode({ lottery_id: this.lottery_id, page: url }, this.$cookie.getCookie('token')).then((res) => {
          if (res.data.code === 200) {
            this.ewm = res.data.data.invite_qrcode
            this.showQcode = true
          } else {

          }
        })
      } else {
        this.showQcode = true
      }
    },
    fetchPrize() {
      if (this.$cookie.getCookie('token') === '') {
        console.log(this.$cookie.getCookie('token'))
        this.$refs.login.login_fn()
        return false
      }
      getDZPPrize({ lottery_id: this.lottery_id }, this.$cookie.getCookie('token')).then((res) => {
        if (res.data.code === 200) {
          res.data.data.prize.forEach((v, i) => {
            v.page = 1
            v.fetch = false
          })
          this.winLists = res.data.data
          this.showWinList = true
        } else {

        }
      })
    },
    fetchDetail() {
      getDZPDetail({ lottery_id: this.lottery_id }, this.$cookie.getCookie('token')).then((res) => {
        if (res.data.code === 200) {
          this.detail = res.data.data
          var arr2 = []
          this.detail.detail.forEach((v, i) => {
            v.prize.forEach((vv, ii) => {
              vv.prize = v.name
              vv.desc = v.desc
              arr2.push(vv)
            })
          })
          this.wins = arr2
          setTimeout(() => {
            this.swiper = new Swiper('.swiper-container', {
              effect: 'coverflow',
              grabCursor: true,
              centeredSlides: true,
              slidesPerView: 'auto',
              autoplay: {
                delay: 3000 // 1秒切换一次
              },
              // loop: true,
              coverflow: {
                rotate: 50,
                stretch: 0,
                depth: 100,
                modifier: 1,
                slideShadows: true
              }
            })
          }, 1500)
        } else {

        }
      })
    },
    refeshDetail() {
      getDZPDetail({ lottery_id: this.lottery_id }, this.$cookie.getCookie('token')).then((res) => {
        if (res.data.code === 200) {
          this.detail = res.data.data
        }
      })
    },
    resize(newRect) {
      this.width = newRect.width
      this.height = newRect.height
      this.top = newRect.top
      this.left = newRect.left
      this.qrCodeScale = this.width / 480
    },
    showWinListHander() {
      this.fetchPrize()
    },
    hideWinListHander() {
      this.showWinList = false
    },
    setScale() {
      if ($(window).width() <= 1920) {
        $('.full-body').css({
          transform:
            'scale(' + $(window).width() / 1920 + ') translate(-50%, -50%)',
          'transform-origin': '0 top'
        })
      } else {
        $('.full-body').css({
          transform: 'scale(1)translate(-50%, -50%)',
          'transform-origin': '0 top'
        })
      }
      if ($(window).width() <= 1552) {
        $('.winning-list').css({
          transform: 'scale(' + $(window).width() / 1552 + ')',
          'transform-origin': '0 center'
        })
      } else {
        $('.winning-list').css({
          transform: 'scale(1)',
          'transform-origin': '0 center'
        })
      }
    },
    fullHandle() {
      var docElm = document.documentElement
      if (docElm.requestFullscreen) {
        docElm.requestFullscreen()
      } else if (docElm.mozRequestFullScreen) {
        docElm.mozRequestFullScreen()
      } else if (docElm.webkitRequestFullScreen) {
        docElm.webkitRequestFullScreen()
      }
    },
    fetchSkinList() {
      getDZPSkinList({ }, this.$cookie.getCookie('token')).then((res) => {
        if (res.data.code === 200) {
          this.skinList = res.data.data
        } else {

        }
      })
    },
    fetchData() {
      console.log('子组件触发登录后，调用父组件方法')
    }
  },
  created() {
    this.lottery_id = this.$route.query.id
    this.fetchDetail()
    this.socket.on('connect', () => {
      console.log('wss 已链接')
      this.isconnect = true
    })
    this.socket.on('disconnect', (reason) => {
      console.log('wss 已断开')
    })
    this.socket.open()
    var time = setInterval(() => {
      console.log('11111')
      console.log(this.isconnect)
      if (this.isconnect === true) {
        // 加入房间
        this.socket.emit('joinroom', 'dzp' + this.lottery_id)
        // 接受wws 信息
        this.socket.on('dzp' + this.lottery_id, (res) => {
          console.log('收到服务器内容：' + res)
          console.log(res)
          if (res.setType === 'win') {
            this.detail.detail.forEach((v, i) => {
              if (res.prize_id === v.id) {
                res.prize = v.name
                res.desc = v.desc
                res.cover = v.cover
                v.hasnum = v.hasnum - 0 + 1
              }
            })
            this.detail.detail = this.detail.detail
            this.$forceUpdate()
            // 收到中奖通知
            this.wins.push(res)
            setTimeout(() => {
              this.$refs.winBoxScroll.scrollTop = this.$refs.winBoxScrollUl.offsetHeight - 576
            }, 500)
            console.log(this.wins)
          }
        })
        clearInterval(time)
      }
    }, 2500)
  },
  destroyed() {
    this.socket.emit('leaveroom', 'dzp' + this.lottery_id)
    // window.removeEventListener('hashchange', this.afterQRScan);
  },
  mounted() {
    var _this = this
    this.$nextTick(() => {
      $(function () {
        _this.setScale()
        _this.left = $(window).width() / 2
        _this.top = $(window).height() / 2 - 550
        setTimeout(() => {
          // console.log(_this.$refs.winBoxScrollUl.offsetHeight)
          // console.log(_this.$refs.winBoxScroll.scrollTop = _this.$refs.winBoxScrollUl.offsetHeight - 576)
          _this.$refs.winBoxScroll.scrollTop = _this.$refs.winBoxScrollUl.offsetHeight - 576
          // console.log($)
          // console.log($('#winBoxScroll'))
          // console.log($('#winBoxScroll ul'))
          // console.log($('#winBoxScroll ul').offsetHeight)
          // $('#winBoxScroll').scrollTop = '1440px'
          // $('#winBoxScroll').scrollTop = $('#winBoxScroll ul').offsetHeight
        }, 1500)
      })
      $(window).resize(() => {
        _this.setScale()
      })
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped rel="stylesheet/scss" lang="scss">
@import url('../assets/css/base.min.css');
@import url('../assets/css/xccjScreen.min.css');
@import url('../assets/css/vueDragResize.min.css');

.playerList {
  .noData {
    text-align: center;
    color: #ffffff;
    margin-bottom: 20px;

  }
}

.morePlayer {
  color: #ffffff;
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
}
.skin_mask{
  width: 100vw;
  height: 100vh;
  background: rgba($color: #000000, $alpha:0.7);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
}
.skinBox{
  width: 80%;
  position: fixed;
  left: 0;
  right: 0;
  height: 80vh;
  top: 50%;
  transform: translateY(-50%);
  margin: 0 auto;
  background: #f2f2f2;
  z-index: 100;
  border-radius: 20px;
  overflow-y: auto;
  .skinItems{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    padding:10px 30px;
    border-radius: 30px;
    .skinItem{
      background: #ffffff;
      width: 250px;
      height: 180px;
      margin: 30px;
      border: 2px solid #d5d5d5;
      box-shadow: 1px 1px 30px rgba($color: #000000, $alpha: 0.3);
      border-radius: 10px;
      overflow: hidden;
      &.active{
        border: 2px solid saddlebrown;
        background: saddlebrown;
        box-shadow: 1px 1px 30px rgba($color: saddlebrown, $alpha: 0.5);
        .title{
          color: #ffffff;
        }
      }
      .imgbox{
        width: 250px;
        height: 130px;
        overflow: hidden;
        position: relative;
        img{
          width: 100%;
          position: absolute;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      .title{
        height:50px;
        line-height: 50px;
        text-align: center;
        font-size: 16px;
        color: #666;
      }
    }
  }
  .closeBtn{
    width: 28px;
    height: 28px;
    position: absolute;
    right: 10px;
    top: 10px;
    img{
      width: 28px;
      height: 28px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/screen.vue